import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Orders(props) {
    return (
        <SvgIcon {...props}>
            <path d="M30 13.1V13v-.2c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.1-.2-.1l-.1-.1-12.7-5.9h-.1c-.1 0-.2-.1-.3-.1H16L2.8 10.8c-.1 0-.2.1-.3.2-.3.1-.6.4-.6.9v6.9c0 .2.1.4.2.6.1.2.2.4.5.5l12.5 5.8c.1 0 .1.1.2.1s.2 0 .3.1h.1c.2 0 .4-.1.5-.2l13-4.4c.3-.1.5-.4.6-.7.1-.2.2-.3.2-.5v-7zM16.2 8.2l9.7 4.5-9.9 3.8-10.1-4.7 10.3-3.6zM3.9 13.1l10.7 5v5.2L3.9 18.2v-5.1zm12.8 5.3L28 14.1v5.4l-11.4 3.8v-5h.1z" />
        </SvgIcon>
    );
}

Orders.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Orders;
